import { Injectable } from '@angular/core';
// import { Http, HttpModule, Headers } from '@angular/http';
import { ParEmployee } from '../../model/par_employees.model';
import 'rxjs/add/operator/map';
import { configURI } from '../../../shared/apiUrlConfig';
// import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Http, Response, RequestOptions, HttpModule, Headers } from '@angular/http';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs';
import { error } from 'protractor';
import { ObservableMedia } from '@angular/flex-layout';
import { Observable } from 'rxjs/Observable';
import { UserFriendlyMsgs } from '../../app.user-msgs';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';


@Injectable()
export class ParEmployeeService {
  load;
  EmployeeId: any;
  result: any;
  loginId;
  url = environment.configURI;
  private getAllPAREmployeeData = "/paremployee/getallparemployees";
  private getEmployeeDataByID = '/paremployee/getparemployeebyempid?employee_id='
  private getClientEmployeeUrl = '/client/par/employees/'
  // httpHeaderOptions = {
  //   headers: new Headers({
  //     'Cache-Control': 'no-cache',
  //     'Pragma': 'no-cache',
  //     'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
  //   })
  // };
  // headers = new Headers({ 'x-access-token': localStorage.getItem('Token'), 'Cache-Control': 'no-cache', 'Pragma': 'no-cache', 'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT' });
  // options = new RequestOptions({ headers: this.headers });

  // httpClientHeaderOptions = {
  //   headers: new HttpHeaders({
  //     'x-access-token': localStorage.getItem('Token'),
  //     'Cache-Control': 'no-cache',
  //     'Pragma': 'no-cache',
  //     'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
  //   })
  // };

  constructor(private httpClient: HttpClient, private http: Http, private userFriendlyMsgs: UserFriendlyMsgs) {
    this.load = new BehaviorSubject('initial');
  }

  getEmployeeByID(id) {
    // this.httpClientHeaderOptions = {
    //   headers: new HttpHeaders({
    //     'x-access-token': localStorage.getItem('Token'),
    //     'Cache-Control': 'no-cache',
    //     'Pragma': 'no-cache',
    //     'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    //   })
    // };
    //this.httpClientHeaderOptions.headers.set('x-access-token', localStorage.getItem('Token'));
    let role = parseInt(localStorage.getItem("RoleVal"));
    if (role === 8) {
      return this.httpClient.get(`${this.url}${this.getClientEmployeeUrl}${id}`)
    } else {
      return this.httpClient.get(`${this.url}${this.getEmployeeDataByID}${id}`)
    }
  }

  //ClientUrl
  getEmployeeByDbId(id) {
    // this.httpClientHeaderOptions = {
    //   headers: new HttpHeaders({
    //     'x-access-token': localStorage.getItem('Token'),
    //     'Cache-Control': 'no-cache',
    //     'Pragma': 'no-cache',
    //     'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    //   })
    // };
    //this.httpClientHeaderOptions.headers.set('x-access-token', localStorage.getItem('Token'));

    // this.headers = new Headers({
    //   'x-access-token': localStorage.getItem('Token'),
    //   'Cache-Control': 'no-cache',
    //   'Pragma': 'no-cache',
    //   'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    // });
    // this.options = new RequestOptions({ headers: this.headers });
    //this.options.headers.set('x-access-token', localStorage.getItem('Token'));
    let role = parseInt(localStorage.getItem("RoleVal"));
    if (role === 8) {
      return this.httpClient.get(`${this.url}${this.getClientEmployeeUrl}${id}`).catch(this.userFriendlyMsgs.errorHandler);
    } else {
      return this.httpClient.get(this.url + '/par/employees/' + id).catch(this.userFriendlyMsgs.errorHandler);
    }
  }

  getParEmployeeBy_Id(employee_id) {
    // this.headers = new Headers({
    //   'x-access-token': localStorage.getItem('Token'),
    //   'Cache-Control': 'no-cache',
    //   'Pragma': 'no-cache',
    //   'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    // });
    // this.options = new RequestOptions({ headers: this.headers });
    //this.options.headers.set('x-access-token', localStorage.getItem('Token'));
    return this.httpClient.get(this.url + '/par/employees/' + employee_id).catch(this.userFriendlyMsgs.errorHandler);
  }

  // Get employee documents data based on employee Id
  getParEmployeeDocumentsBy_EmpId(employee_id) {
    // this.headers = new Headers({
    //   'x-access-token': localStorage.getItem('Token'),
    //   'Cache-Control': 'no-cache',
    //   'Pragma': 'no-cache',
    //   'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    // });
    // this.options = new RequestOptions({ headers: this.headers });
    //this.options.headers.set('x-access-token', localStorage.getItem('Token'));
    let role = parseInt(localStorage.getItem("RoleVal"));
    if (role === 8) {
      return this.httpClient.get(this.url + '/client/par/employee/' + employee_id + '/documents').catch(this.userFriendlyMsgs.errorHandler);
    } else {
      return this.httpClient.get(this.url + '/par/employee/' + employee_id + '/documents').catch(this.userFriendlyMsgs.errorHandler);
    }
  }

  // get Par employees
  getParEmployees() {
    // this.headers = new Headers({
    //   'x-access-token': localStorage.getItem('Token'),
    //   'Cache-Control': 'no-cache',
    //   'Pragma': 'no-cache',
    //   'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    // });
    // this.options = new RequestOptions({ headers: this.headers });
    //this.options.headers.set('x-access-token', localStorage.getItem('Token'));
    let role = parseInt(localStorage.getItem("RoleVal"));
    if (role === 8) {
      return this.httpClient.get(this.url + '/client/par/employee').catch(this.userFriendlyMsgs.errorHandler);
    } else {
      return this.httpClient.get(this.url + '/par/employee').catch(this.userFriendlyMsgs.errorHandler);
    }
  }

  getClientParEmployess() {
    // this.headers = new Headers({
    //   'x-access-token': localStorage.getItem('Token'),
    //   'Cache-Control': 'no-cache',
    //   'Pragma': 'no-cache',
    //   'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    // });
    // this.options = new RequestOptions({ headers: this.headers });
    //this.options.headers.set('x-access-token', localStorage.getItem('Token'));
    return this.httpClient.get(this.url + '/client/par/employee').catch(this.userFriendlyMsgs.errorHandler);
  }

  // add Par employee
  addParEmployee(parEmployee) {
    // this.headers = new Headers({
    //   'x-access-token': localStorage.getItem('Token'),
    //   'Cache-Control': 'no-cache',
    //   'Pragma': 'no-cache',
    //   'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    // });
    // this.options = new RequestOptions({ headers: this.headers });
    //this.options.headers.set('x-access-token', localStorage.getItem('Token'));
    parEmployee.created_by = this.loginId;
    return this.httpClient.post(this.url + '/par/employee', parEmployee).catch(this.userFriendlyMsgs.errorHandler);
  }

  // update PAREmployee
  parEmployeeEdited(data) {
    const body = {
      first_name: data.first_name,
      last_name: data.last_name,
      hire_date: data.hire_date,
      role: data.role,
      updated_by: '',
      employee_id: data.employee_id,
    };

    // this.headers = new Headers({
    //   'x-access-token': localStorage.getItem('Token'),
    //   'Cache-Control': 'no-cache',
    //   'Pragma': 'no-cache',
    //   'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    // });
    // this.options = new RequestOptions({ headers: this.headers });
    //this.options.headers.set('x-access-token', localStorage.getItem('Token'));
    this.loginId = localStorage.getItem('loginID');
    body.updated_by = this.loginId;
    return this.httpClient.put(this.url + '/par/employees/' + data._id, body).catch(this.userFriendlyMsgs.errorHandler);
  }

  // delete Par employees
  deleteParEmployee(data) {
    // this.headers = new Headers({
    //   'x-access-token': localStorage.getItem('Token'),
    //   'Cache-Control': 'no-cache',
    //   'Pragma': 'no-cache',
    //   'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    // });
    // this.options = new RequestOptions({ headers: this.headers });
    //this.options.headers.set('x-access-token', localStorage.getItem('Token'));
    return this.httpClient.delete(this.url + '/par/employees/' + data).catch(this.userFriendlyMsgs.errorHandler);
  }

  // Get Document type values
  getParEmployeeDocumentType() {
    // this.headers = new Headers({
    //   'x-access-token': localStorage.getItem('Token'),
    //   'Cache-Control': 'no-cache',
    //   'Pragma': 'no-cache',
    //   'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    // });
    // this.options = new RequestOptions({ headers: this.headers });
    //this.options.headers.set('x-access-token', localStorage.getItem('Token'));
    return this.httpClient.get(this.url + '/documents/GetDocumentTypesByCategory?Category=PAREMPLOYEE').catch(this.userFriendlyMsgs.errorHandler);
  }

  addParEmployeeDocuments(documents) {
    // this.headers = new Headers({
    //   'x-access-token': localStorage.getItem('Token'),
    //   'Cache-Control': 'no-cache',
    //   'Pragma': 'no-cache',
    //   'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    // });
    // this.options = new RequestOptions({ headers: this.headers });
    //this.options.headers.set('x-access-token', localStorage.getItem('Token'));
    return this.httpClient.post(this.url + '/par/employees/documents', documents)
      //  return this.http.post(this.url + '/par/employee', parEmployee, { headers: headers })
  .catch(this.userFriendlyMsgs.errorHandler);
  }

  // delete PAR employees Document
  deleteParEmployeeDocument(data) {
    // this.headers = new Headers({
    //   'x-access-token': localStorage.getItem('Token'),
    //   'Cache-Control': 'no-cache',
    //   'Pragma': 'no-cache',
    //   'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    // });
    // this.options = new RequestOptions({ headers: this.headers });
    //this.options.headers.set('x-access-token', localStorage.getItem('Token'));
    return this.httpClient.delete(this.url + '/par/employees/document/' + data).catch(this.userFriendlyMsgs.errorHandler);
  }

  // update PAREmployee Documents
  parEmployeeDocumentEdited(data) {
    // this.headers = new Headers({
    //   'x-access-token': localStorage.getItem('Token'),
    //   'Cache-Control': 'no-cache',
    //   'Pragma': 'no-cache',
    //   'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    // });
    // this.options = new RequestOptions({ headers: this.headers });
    //this.options.headers.set('x-access-token', localStorage.getItem('Token'));
    const body = {
      file_name: data.file_name,
      expiration_date: data.expiration_date,
      document_link: data.document_link,
      issue_date: data.issue_date,
      completion_date: data.completion_date,
      uploaded_date: data.uploaded_date
    }
    return this.httpClient.put(this.url + '/par/employees/document/' + data.docid, body).catch(this.userFriendlyMsgs.errorHandler);
  }

  // GetPARSummaryData
  getParSummary() {
    // this.headers = new Headers({
    //   'x-access-token': localStorage.getItem('Token'),
    //   'Cache-Control': 'no-cache',
    //   'Pragma': 'no-cache',
    //   'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    // });
    // this.options = new RequestOptions({ headers: this.headers });
    //this.options.headers.set('x-access-token', localStorage.getItem('Token'));
    //  return this.http.get(this.url + '/par/summary')
    let role = parseInt(localStorage.getItem("RoleVal"))
    if (role === 8) {
      return this.httpClient.get(this.url + '/client/par/summary').catch(this.userFriendlyMsgs.errorHandler);
    } else {
      return this.httpClient.get(this.url + '/par/summary').catch(this.userFriendlyMsgs.errorHandler);
    }
  }

  parSummaryDataEdited(data) {
    // this.headers = new Headers({
    //   'x-access-token': localStorage.getItem('Token'),
    //   'Cache-Control': 'no-cache',
    //   'Pragma': 'no-cache',
    //   'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    // });
    // this.options = new RequestOptions({ headers: this.headers });
    //this.options.headers.set('x-access-token', localStorage.getItem('Token'));
    const body = {
      summary_id: data.summary_id,
      name: data.name,
      type: data.type,
      date_incorporated: data.date_incorporated,
      state_incorporated: data.state_incorporated,
      address: data.address,
      phone: data.phone,
      description: data.description,
      audit_financials: data.audit_financials,
      dunn_and_bradstreet: data.dunn_and_bradstreet,
      taxid: data.taxid,
      website: data.website,
      public_or_private: data.public_or_private,
      compliance_contract: data.compliance_contract,
      no_of_employees: data.no_of_employees
    };
    return this.httpClient.put(this.url + '/par/summary', body).catch(this.userFriendlyMsgs.errorHandler);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/par_employees/par_employees.service.ts